import Page from "../../components/Page/Page";
import { Row, Col, Select, Form, Input, Modal } from "antd";
import ProductItem from "../../components/eCommerce/ProductItem";
import CircularProgress from "../../components/CircularProgress";
import { GetWithExpiry } from "../../util/sessionManager";
import { GetProductGoroups, GetProducts } from "../../API/products";

import Classes from "./index.module.css";
import { useState, useEffect } from "react";
import Widget from "../../components/Widget";

const groups = ["a", "b", "c", "d"];
const ErrorModal = Modal.error;
const Search = Input.Search;
export default function ItemsCatalog({}) {
  const [products, setProducts] = useState(GetWithExpiry("products")?GetWithExpiry("products"):[]);
  const [displayedProduct, setDisplayedProduct] = useState([...products]);
  const [searchGroups, setSearchGroups] = useState(GetWithExpiry("productGroups")?GetWithExpiry("productGroups"):[]);
  const [groups,setGroups] = useState([]);
  const [searchGroup, setSearchGroup] = useState("*");
  const [loaing, setLoading] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(true);
  useEffect(() => {
    if (!products.length) {
      setLoading(true);
      GetProducts()
        .then((i) => {
          if (i.success) {
            setProducts(GetWithExpiry("products"));
          }
          console.log(i);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, [products]);
  useEffect(() => {
    if (!groups.length) {
      setLoading(true);
      GetProductGoroups()
        .then((i) => {
          if (i.success) {
            setGroups(GetWithExpiry("productGroups"));
          }
          console.log(i);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگام دریافت گروه ها" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, [groups]);
  useEffect(() => {
    setDisplayedProduct(products);
  }, [products]);

  const onChangeHandler = (value) => {
    setSearchGroup(value);
  };
  const onSearch = (value, _e, info) => {
    setDisplayedProduct(
      products.filter((i) => {
        if (searchGroup != "*") {
          if (
            (i.name.toString().includes(value) ||
              i.id.toString().includes(value)) &&
            i.group.includes(searchGroup)
          ) {
            return i;
          }
        } else {
          if (
            i.name.toString().includes(value) ||
            i.id.toString().includes(value)
          ) {
            return i;
          }
        }
      })
    );
  };

  return (
    <>
      <Row className={Classes.searchForm}>
        <Widget styleName={Classes.sertformInputs}>
          <Form.Item>
            <Select showSearch defaultValue={"*"} onChange={onChangeHandler}>
              <Select.Option value={"*"}>همه</Select.Option>
              {groups.map((i) => (
                <Select.Option value={i.code}>{i.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Search
              placeholder="جستوجو نام و کد"
              onSearch={onSearch}
              allowClear
              enterButton
            />
          </Form.Item>
        </Widget>
      </Row>
      <Row>
        {loaing && <CircularProgress />}
        {displayedProduct.map((product, index) => (
          <Col key={index} span={24}>
            <ProductItem
              key={index}
              product={product}
              priviliges={JSON.parse(localStorage.getItem("privilage"))}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}
